import React, { Component } from 'react';
import Questions from './Questions';
import { translate } from 'react-polyglot';

class QuestionGender extends Component {
  render() {
    var newOptions = Object.assign(
      {},
      {
        choices: [{ gender_ui: 'male' }, { gender_ui: 'female' }],
        multiSelect: false,
      },
      this.props.options,
    );

    return <Questions {...this.props} options={newOptions} />;
  }
}

export default translate()(QuestionGender);



// WEBPACK FOOTER //
// ./src/components/instore/QuestionGender.js